<template>
  <div class="nin-verify my-5">
    <b-form class="form"
            @submit.stop.prevent="confirm">
      <div class="d-flex flex-column">
        <p class="title mb-5">
          {{$t('verification.verifyTC')}}
        </p>
        <p class="mb-5">
          {{$t('verification.verifyYourIdentityNumberInfoText')}}
        </p>
        <b-form-group id="fullname-group"
                      label-for="fullname-input"
                      class="mb-5">
          <b-form-input id="fullname-input"
                        name="fullname"
                        v-model.trim="$v.form.fullname.$model"
                        :state="validateState('fullname')"
                        aria-describedby="fullname-input-live-feedback"
                        :placeholder="$t('verification.fullname')"></b-form-input>

          <b-form-invalid-feedback id="fullname-input-live-feedback">
            {{ $t('verification.fullnameIsRequired') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <DateTime placeholder="verification.birthDateWithFormat"
                  v-model="form.birthdate"
                  valueFormat="YYYY-MM-DD"
                  :langVal="$i18n.locale"
                  :state="validateState('birthdate')"></DateTime>

        <!-- <b-form-group id="birthDateGroup"
                      label-for="birthDate"
                      class="mb-5">
                      
          <b-form-input id="birthDate"
                        v-model="form.birthdate"
                        v-mask="['##/##/####']"
                        :state="validateState('birthdate')"
                        :placeholder="$t('verification.birthDateWithFormat')"></b-form-input>
          <b-form-invalid-feedback id="birthDate-input-live-feedback">
            {{ $t('verification.birthDateIsRequired') }}
          </b-form-invalid-feedback>
        </b-form-group> -->

        <b-form-group id="identity-group"
                      label-for="identity-input"
                      class="mb-5">
          <b-form-input v-model="$v.form.identity.$model"
                        :state="validateState('identity')"
                        :placeholder="$t('verification.identityNumber')"></b-form-input>

          <b-form-invalid-feedback id="identity-input-live-feedback">
            {{ $t('verification.identityIsRequired') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <p class="mb-5">* {{$t('verification.birthDateRequiredFormat')}}</p>
        <button class="btn btn-primary w-100 d-block px-9 py-3 rounded"
                ref="confirm_button">{{ $t('verification.confirm') }}</button>
      </div>
    </b-form>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { VERIFY_REGISTERED_USER } from '@/core/services/store/auth.module'

export default {
  name: 'NinVerify',
  mixins: [validationMixin],
  data() {
    return {
      form: {
        fullname: '',
        identity: '',
        birthdate: '',
      },
    }
  },
  validations: {
    form: {
      identity: {
        required,
        minLength: minLength(11),
      },
      birthdate: {
        required,
        // minLength: minLength(10),
        // birthdate(birthdate) {
        //   return (
        //     moment(birthdate, 'MM-DD-YYYY').format('YYYY-MM-DD') !=
        //     'Invalid date'
        //   )
        // },
      },
      fullname: {
        required,
        minLength: minLength(3),
        isFullname(fullname) {
          return /^[a-zA-Z_ğüşıöçĞÜŞİÖÇ]+(?:\s[a-zA-Z_ğüşıöçĞÜŞİÖÇ]+)+$/gm.test(
            fullname
          ) // check full name
        },
      },
    },
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }

      // set spinner to submit button
      const confirmButton = this.$refs['confirm_button']
      this.$spinnerLoader.addSpinnerLoader(confirmButton)

      // if (
      //   moment(this.form.birthdate, 'MM-DD-YYYY').format('YYYY-MM-DD') ===
      //   'Invalid date'
      // ) {
      //   this.$generateToast(
      //     this,
      //     'danger',
      //     this.$t('verification.invalidBirthDate')
      //   )
      //   this.$spinnerLoader.removeSpinnerLoader(confirmButton)
      // } else {
      this.userBirthdateUpdate()
        .then((res) => {
          this.userIdentityUpdate()
        })
        .catch((err) => {
          this.$generateToast(
            this,
            'danger',
            this.$t('verification.birthDataUpdateError')
          )
          this.$spinnerLoader.removeSpinnerLoader(confirmButton)
        })
      // }
    },
    userBirthdateUpdate() {
      let name = this.form.fullname.split(' ').slice(0, -1).join(' ')
      let surname = this.form.fullname.split(' ').slice(-1).join(' ')

      return new Promise((resolve, reject) => {
        // ApiService.put(`users/${this.currentUser.user.id}`, {
        ApiService.put(`users/me`, {
          name: name,
          surname: surname,
          birthday: this.form.birthdate,
          // birthday: moment(this.form.birthdate, 'MM-DD-YYYY').format(
          //   'YYYY-MM-DD'
          // ),
        })
          .then((res) => {
            resolve(res.data.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    userIdentityUpdate() {
      const confirmButton = this.$refs['confirm_button']
      ApiService.put(`users/me/nin/verify`, {
        citizen: 1,
        nin: this.form.identity,
      })
        .then((res) => {
          this.$store
            .dispatch(VERIFY_REGISTERED_USER, this.currentUser.user.email)
            .then((res) => {
              if (res.nin_validated) {
                this.$generateToast(
                  this,
                  'success',
                  this.$t('verification.identityNumberConfirmed')
                )
              } else {
                this.$generateToast(
                  this,
                  'danger',
                  this.$t('verification.identityNumberConfirmError')
                )
              }
              this.$spinnerLoader.removeSpinnerLoader(confirmButton)
            })
        })
        .catch((err) => {
          this.$spinnerLoader.removeSpinnerLoader(confirmButton)

          if (err == 'Error') {
            this.$generateToast(
              this,
              'danger',
              this.$t('global.anErrorHasOccurred')
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.nin-verify {
  border: 1px dashed #e5eaee;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #80808f;
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 25px;
    color: #212121;
  }
}
</style>